<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <span />
      </template>
    </app-breadcrumb>
    <h3 style="font-size: 1.2rem;padding-left: 5px;">
      <router-link :to="prevRoutePath" class="btnBack"><font-awesome-icon icon="fa-reply" @click="handleBack" /> Quay
        lại</router-link>
      <b>{{ title }}</b>
    </h3>

    <div class="card">
      <b-table ref="refListTable" class="position-relative" :items="itemsData" responsive :fields="tableColumns"
        primary-key="id" show-empty empty-text="Chưa có dư liệu">
        <template #cell(title)="data">
          <p class="m-0 text-wrap"> {{ data.item.title }} </p>
          <span class="badge" :class="`badge-` + data.item.status_color">{{ data.item.status_text }}</span>
        </template>
        <!-- Column: Status -->
        <template #cell(status)="data">
          <div class="d-flex justify-content-between">
            <b-form-radio v-model="first_id" :value="data.item.id" :disabled="last_id == data.item.id" />
            <b-form-radio v-model="last_id" :value="data.item.id" :disabled="first_id == data.item.id" />
          </div>
        </template>
      </b-table>
    </div>
    <div class="d-flex justify-content-end ">
      <b-button type="button" variant="success" @click="articleHistory">So
        sánh</b-button>
    </div>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormCheckbox,
  BBadge, BDropdown, BDropdownItem, BPagination, BInputGroupAppend, BInputGroup, BFormRadio,
} from 'bootstrap-vue'
import {
  ref, watch, computed, onMounted,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import moment from 'moment'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faThumbsUp, faReply } from '@fortawesome/free-solid-svg-icons';
library.add(faThumbsUp, faReply);
export default {
  components: {
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    FontAwesomeIcon,
  },
  data() {
    return {
      checked: false,
      prevRoute: ''
    }
  },
  beforeRouteEnter(to, from, next) {

    next(vm => {
      vm.prevRoute = from
    });
  },
  computed: {
    prevRoutePath() {

      return this.prevRoute ? this.prevRoute.path : '/article/private'
    },
  },
  mounted() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', false);
  },
  setup() {
    const refListTable = ref(null)
    const { route, router } = useRouter();
    const back_url = ref('')
    // Table Handlers
    const tableColumns = [
      {
        key: 'title', sortable: false, label: 'Phiên bản', thClass: 'col-8',
      },
      {
        key: 'note',
        sortable: false,
        label: 'Ghi chú',
        thClass: 'col-3',
        tdClass: 'col-3',
      },
      {
        key: 'status',
        sortable: false,
        label: '',
        thClass: 'col-1 col-xs-2',
        tdClass: 'col-1 col-xs-2',
      },
    ];
    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 30, 50, 100]
    const itemsData = ref([]);
    const first_id = ref(null);
    const last_id = ref(null);
    const title = ref('')
    const article_id = route.value.params.id !== undefined ? route.value.params.id : 0;
    const fetchAll = () => {
      store.dispatch('article/history', {
        article_id,
        perPage: perPage.value,
        page: currentPage.value,

      })
        .then(response => {
          const result = response.data;

          if (result.code === 200) {
            title.value = result.data.title

            itemsData.value = result.data.data
            total.value = result.data.total;
          } else {
            // thong bao loi
          }
        })
    }
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([currentPage, perPage], () => {
      refetchData()
    })

    const refetchData = () => {
      fetchAll()
    }

    onMounted(() => {
      fetchAll()
    })

    return {
      fetchAll,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      itemsData,
      first_id,
      last_id,
      title,
      back_url
    }
  },
  methods: {
    handleBack() {
      console.log('handleBack', this.lastPath)
    },
    format_datetime(value) {
      return moment.unix(value).format('YYYY/MM/DD - HH:mm')
    },
    articleHistory() {
      const article_id = this.$route.params.id;
      if (!article_id || !this.first_id || !this.last_id) {
        this.$swal({
          text: 'Chưa chọn phiên bản cần so sánh',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      } else {
        const url = `/article/${article_id}/diff/${this.first_id}/${this.last_id}`;
        this.$router.push({ path: url });
      }
    },
  },
}
</script>

<style lang="scss">
.statusText {
  padding: 0.4rem;
  font-size: 0.9rem
}

.note {
  width: 20%;
}

.btnBack {
  margin-right: 1rem;
  color: #ff9f43;
  border-right: 1px solid #c6c4c4;
  padding-right: 1rem;
  cursor: pointer;

  &:hover {
    color: #ff9f43;
  }
}
</style>
